import axios from "axios";
import { clearSession } from "../utils/session";

// Base URL
const API = axios.create({
    baseURL: 'https://api.antipsun.com/api/',
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Request Interceptor
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor — clear full session on 401
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearSession();
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

// GET
export const getApi = (url, params = {}) =>
    API.get(url, { params });

// POST
export const postApi = (url, data = {}) =>
    API.post(url, data);

// PUT
export const putApi = (url, data = {}) =>
    API.put(url, data);

// PATCH
export const patchApi = (url, data = {}) =>
    API.patch(url, data);

// DELETE
export const deleteApi = (url) =>
    API.delete(url);

export default API;